import { Box, Drawer } from '@mui/material';
import Loading from 'components/common/Loading';
import { bool, object } from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import channels from 'store/app/entities/channels/action';
import channelDrawer from 'store/app/ui/drawers/channel/action';
import currentChannel from 'store/selectors/currentChannel';
import employeesStatus from 'store/selectors/employeesStatus';
import CloseButton from '../CloseButton';
import ChannelForm from './Form';

const ChannelFormComponent = ({ isEdit, channel }) => {
  const { isLoading } = useSelector(employeesStatus);
  if (isLoading || (isEdit && channel.loading)) {
    return <Loading />;
  }
  if (!isEdit || channel.loaded) {
    return <ChannelForm />;
  }
  return null;
};

ChannelFormComponent.propTypes = {
  isEdit: bool.isRequired,
  channel: object.isRequired,
};

const ChannelDrawer = () => {
  const isOpen = useSelector(state => state.drawers.channel.isOpen);
  const channel = useSelector(currentChannel);
  const isEdit = useSelector(state => state.drawers.channel.type === 'edit');
  const dispatch = useDispatch();

  useEffect(() => {
    if (isEdit && isOpen && channel?._id && !channel.loading && !channel.loaded) {
      dispatch(channels.find(channel._id));
    }
  }, [isEdit, isOpen, channel, dispatch]);

  const handleClose = useCallback(() => {
    dispatch(channelDrawer.close());
  }, [dispatch]);

  return (
    <Drawer anchor="right" open={isOpen} onClose={handleClose}>
      <Box
        sx={theme => ({
          display: 'flex',
          flex: 1,
          justifyContent: 'center',
          width: '100%',
          maxWidth: 'calc(100vw - 40px)',
          [theme.breakpoints.up('md')]: {
            width: 1100,
          },
        })}
      >
        <Box sx={{ pt: '20px', pl: '20px' }}>
          <CloseButton onClick={handleClose} />
        </Box>
        <Box sx={{ display: 'flex', flex: 1 }}>
          <ChannelFormComponent isEdit={isEdit} channel={channel} />
        </Box>
      </Box>
    </Drawer>
  );
};

export default ChannelDrawer;
